const memberInputClasses = [
  'add-new-member-input',
  'ico-add-member',
  'close-icon',
  'add-plus'
];

export default memberInputClasses;
